<section>
  @if (componentLoaded()) {
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-xs-12 last-xs">
          @if (openingSoonImage(); as scheduleImage) {
            <div class="schedule-image">
              <app-image [image]="scheduleImage" [keepAspectRatio]="true" [size]="{ dw: 400 }" />
            </div>
          } @else {
            @let schedules = storeScheduleDetails()?.schedules;
            @let specialOpening = storeScheduleDetails()?.specialOpening;
            @if (schedules && schedules.length > 0) {
              @if (scheduleTitle()) {
                <app-title [titles]="[scheduleTitle()]" class="title-schedule" />
              }
              @let isMiddleOfficeToken = (isMiddleOfficeToken$ | async) ?? false;
              <app-schedule
                [isMiddleOffice]="isMiddleOfficeToken"
                [schedules]="schedules"
                [specialOpening]="specialOpening" />
            }
          }
        </div>
        <div class="col-lg-6 col-lg-offset-2 col-xs-12 last-lg">
          @if (title()) {
            <app-title [titles]="[title()]" class="title" />
          }
          @if (reviews() && reviews().totalReviews !== undefined && reviews().averageGrade !== undefined) {
            <app-rate [advice]="reviews().totalReviews" [mean]="reviews().averageGrade" [url]="data().rate.url" />
          }
          @if (data().address; as address) {
            <p class="address">
              A.
              <a class="link" href="https://maps.google.com/?q={{ address }}" target="_blank">{{ address }}</a>
            </p>
          }
          @if (data().phone; as phone) {
            <p class="phone">
              T.
              <a class="link" href="tel:{{ phone }}">{{ phone }}</a>
            </p>
          }
          @if (data().html; as html) {
            <div [innerHTML]="html" class="paragraph"></div>
          }
          @if (data().cta; as cta) {
            <app-button [label]="cta.label" [queryParams]="rdvParams()" [routerLink]="cta.url" theme="BLUE" />
          }
        </div>
      </div>
    </div>
  }
</section>
